import { Button, KIND, SIZE } from 'baseui/button';
import { HeadingLarge, LabelLarge, ParagraphMedium } from 'baseui/typography';

import { Block } from 'baseui/block';
import profilePicLight from '../assets/profile-light.jpg';
import profilePicDark from '../assets/profile-dark.jpg';
import { useIsDark } from '../contexts/ThemeContext';
import { useStyletron } from 'baseui';
import { useTranslation } from 'react-i18next';

interface AboutProps {
  onContactClick: () => void;
  onExperienceClick: () => void;
}

export default function About({ onContactClick, onExperienceClick }: AboutProps) {
  const [css, theme] = useStyletron();
  const { t } = useTranslation();
  const isDark = useIsDark();

  return (
    <Block>
      <Block marginBottom="scale700" display="flex" justifyContent="center">
        <img
          src={isDark ? profilePicDark : profilePicLight}
          alt="Matthew Bluestein"
          className={css({
            width: '160px',
            height: '160px',
            borderRadius: '50%',
            objectFit: 'cover',
            display: 'block',
            border: `3px solid ${isDark ? '#A08860' : theme.colors.borderOpaque}`,
            boxShadow: '0 8px 32px rgba(0,0,0,0.35), 0 2px 8px rgba(0,0,0,0.2)',
          })}
        />
      </Block>

      <HeadingLarge
        marginTop="0"
        marginBottom="scale100"
        overrides={{
          Block: {
            style: {
              textAlign: 'center',
              color: isDark ? '#A08860' : theme.colors.borderOpaque,
              textShadow: isDark
                ? '0 2px 8px rgba(0,0,0,0.4)'
                : '0 2px 8px rgba(255,255,255,0.4)',
            },
          },
        }}
      >
        Matthew Bluestein
      </HeadingLarge>

      <LabelLarge
        marginBottom="scale1000"
        overrides={{ Block: { style: { textAlign: 'center', display: 'block' } } }}
      >
        {t('about.role')}
      </LabelLarge>

      <ParagraphMedium color="contentSecondary" marginTop="0" overrides={{ Block: { style: { textAlign: 'center' } } }}>
        {t('about.bio1')}
      </ParagraphMedium>

      <Block display="flex" flexDirection="row" gridGap={theme.sizing.scale500} marginTop="scale1000">
        <Button onClick={onExperienceClick} size={SIZE.default} overrides={{ BaseButton: { style: { flex: '1' } } }}>
          {t('about.viewExperience')}
        </Button>
        <Button onClick={onContactClick} kind={KIND.secondary} size={SIZE.default} overrides={{ BaseButton: { style: { flex: '1' } } }}>
          {t('about.getInTouch')}
        </Button>
      </Block>
    </Block>
  );
}
